
export const CONFIG = {
  GA_ID: window.__ENV__?.REACT_APP_GA_ID ?? '',          
  TURNSTILE_SITEKEY: window.__ENV__?.REACT_APP_TURNSTILE_SITEKEY ?? '',
  SMART_CITY: window.__ENV__?.REACT_APP_SMART_CITY ?? 'https://digital-test.zp.gov.ua/hub/profile',
} as const satisfies {
  GA_ID: string;
  TURNSTILE_SITEKEY: string;
  SMART_CITY: string;
};



